import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { set } from "date-fns";
import { withQueryParams } from "../helpers/common.js";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "date-fns/locale";
import "../appointment-details.types.js";
import "react/jsx-runtime";
import "axios";
const getTimeSlots = (axios, clinicReferenceId) => async (params, signal) => {
  const { data } = await axios.get("api/v1/internal/time-slots", {
    signal,
    params: {
      ...params,
      clinicReferenceId
    }
  });
  return data ?? [];
};
const useTimeSlots = ({
  clinicReferenceId,
  params: { start, end, employeeReferenceIds, ...params },
  disabled
}) => {
  const { echoCore, auth } = useAxiosProvider();
  const queryKey = useMemo(
    () => [
      "time-slots",
      {
        ...params,
        ...employeeReferenceIds && {
          employeeReferenceIds: employeeReferenceIds.join(",")
        },
        start: set(start, { hours: 7, minutes: 0, seconds: 0 }),
        end: set(end, { hours: 21, minutes: 0, seconds: 0 })
      }
    ],
    [params, start, end, employeeReferenceIds]
  );
  const enabled = !!clinicReferenceId && !!auth && !disabled && (!!(params == null ? void 0 : params.treatmentReferenceId) || !!(params == null ? void 0 : params.treatmentBundleReferenceId));
  const { data, ...queryResult } = useQuery({
    // @ts-expect-error TODO:
    queryKey,
    queryFn: withQueryParams(getTimeSlots(echoCore, clinicReferenceId ?? "")),
    keepPreviousData: true,
    enabled
  });
  return {
    queryKey,
    queryResult,
    data
  };
};
export {
  useTimeSlots
};
